<div class="dialog-container">
<div class="dialog-header">
  <mat-label id="addVisit" class="header-text"><b>{{ 'Disclaimer.DisclaimerHeader' | translate}}</b></mat-label>
  <span class="icon-close" color="primary" (click)="Dismiss()"></span>
</div>
<div fxLayout="column">
  <div [ngClass]="{'scrollDisclaimer': true}">
  <div class="row contentPosition">
    <div fxFlex="100">
      <div [innerHtml]="disclaimersIntroductionText" ></div>
    </div>
    <div fxFlex="100">
      {{ 'Disclaimer.HeaderText' | translate}}
    </div>
  </div>
  <div>
  <div class="row contentPosition checkbox-row">
    <mat-checkbox  [(ngModel)]="disclaimerData.termsOfUse" color="primary">
      <span class="checkbox-text">{{ 'Disclaimer.TermsOfUseText' | translate}}
      <u><a class="linktextColor" (click)="NavigateToLabsiteInformation('TermsOfUse')"> {{'Disclaimer.SeeDetailsText' |
          translate }}</a></u></span>
    </mat-checkbox>
  </div>

  <div class="row contentPosition checkbox-row">
    <mat-checkbox  [(ngModel)]="disclaimerData.dataPrivacy" color="primary">
      <span class="checkbox-text">{{ 'Disclaimer.DataPrivacyText' | translate}}
      <u><a class="linktextColor" (click)="NavigateToLabsiteInformation('DataPrivacyPage')">
          {{'Disclaimer.SeeDetailsText' |
          translate }}</a></u><br>
      {{ 'Disclaimer.DataPrivacyAuthorizeText' | translate}}{{labsiteName}}
      {{ 'Disclaimer.DataPrivacyAdditionalText' | translate}}</span>
    </mat-checkbox>
  </div>


  <div class="row contentPosition checkbox-row">
    <mat-checkbox  [(ngModel)]="disclaimerData.volunteerRules" color="primary">
      <span class="checkbox-text">{{ 'Disclaimer.VolunteerRulesText' | translate}}
      <u><a class="linktextColor" (click)="NavigateToLabsiteInformation('VolunteerRulesPage')">
          {{'Disclaimer.SeeDetailsText' |
          translate }}</a></u></span>
    </mat-checkbox>
  </div>
<div fxLayout="row" fxLayoutAlign="end center">
  <button mat-raised-button class="nav-btn navButton" color="primary" (click)="Confirm()" id="confirmButton"
 [disabled]="!CanConfirm()">{{
    'Disclaimer.ConfirmButtonText' | translate}}</button>
</div>

</div>
</div>
</div>
</div>
